//-- Copyright (c) 2021 TMT Insights Group, LLC
// @ts-nocheck
import React from 'react';
import { Thumbnail, TitleTypeLabel, DateTimeDisplay } from '@tmt-insights/oms_fe_core/columns';
import { Typography } from '@tmt-insights/oms_fe_core/material';
import { getLineageMetaTitle } from '@tmt-insights/oms_fe_core/utils';
import { AllTableColumnsConfig } from '@tmt-insights/oms_fe_core';
import { LineageMeta, TitleEntity } from '@/redux/slices/slice_types';

const columns: AllTableColumnsConfig<TitleEntity> = {
  thumbnail_link: {
    label: '',
    disableSort: true,
    width: 50,
    render: (cell: TitleEntity['thumbnail_link'], row: TitleEntity) => <Thumbnail src={cell || row.cover_art_url} type={row.entity_type} />
  },
  hid: {
    label: 'Title ID',
    sortField: 'id',
    render: (cell: TitleEntity['external_id']) => (cell ? <strong style={{ color: 'var(--primary-main)' }}>{cell}</strong> : '-')
  },
  name: {
    label: 'Title',
    minWidth: 280,
    render: (cell: TitleEntity['name'], row: TitleEntity) => (
      <>
        <div>{cell}</div>
        <Typography variant="caption" sx={{ lineHeight: 1.9, fontSize: '.9rem' }}>
          {getLineageMetaTitle(row)}
        </Typography>
      </>
    )
  },
  entity_type: {
    label: 'Type',
    render: (cell: TitleEntity['entity_type']) => <TitleTypeLabel type={cell} />
  },
  created_at: {
    label: 'Created Date',
    minWidth: 100,
    render: (cell: TitleEntity['created_at']) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  },
  updated_at: {
    label: 'Updated At',
    minWidth: 100,
    render: (cell: TitleEntity['updated_at']) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  }
};

export default columns;
